<template>
<div class="main-in">
    <div class="container" v-cloak>
        <div is='titlebox' :nav='JSON.parse(nav)'></div>
        <div class="content">
            <!-- <div class="left-corner">
                 <div class="card-header f-row-l">
                    <div class="bg-title1 f-row-c bbact">{{title}}</div>
                </div>
            </div> -->
            <div class="min-h">
                <div class="f-row-l align-start">
                    <div class="navbox">
                        <div class="defbtn bb-1" :class="ind==act?'brief':''" v-for='(item,ind) in brief2' :key="ind" @click="btn(ind)">{{item.label}}</div>
                    </div>
                    <div :class="brief2.length>0?'words-r':'w-100'">
                        <ul  v-for="(item, i) in list" :key="i" :title="item.title">
                            <li @click="Xx(item)" class="pinter act-h">
                                <div class="triangle"></div>
                                {{ item.leagueTitle?item.leagueTitle:''}}
                                <span>{{ item.createTime }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 分页 -->
            <!-- <div class="block">
                <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="param.pageNo"
                :page-size="param.pageSize"
                layout="prev, pager, next, jumper"
                :total="param.total">
                </el-pagination>
            </div> -->
        </div>
        
    </div>
</div>
</template>
<script>
import {lists} from '@/axios/api'
export default {
    computed:{
        nav:function(){ 
            var arr=[
                {
                    label:this.title,
                    path:'/regiment/list',
                    type:this.$route.query.type
                },
            ]
            return JSON.stringify(arr)
        }
    },
    data(){
        return{
            list:[],
            brief2:[],
            title:'',
            param:{
                pageNo:1,//分页 
                pageSize:10,
                total: 0,
            }
        }
    },
     mounted(){
        this.typeIs();
    },
    methods: {
        typeIs(){
            this.title='团章';
            this.lists();
        },
        handleSizeChange(val) {
            this.$util.goTop()
            console.log(`每页 ${val} 条`);
            this.param.pageSize=val;
            this.lists();
        },
        handleCurrentChange(val) {
            this.$util.goTop()
            console.log(`当前页: ${val}`);
            this.param.pageNo=val;
            this.lists();
        },
        Xx(item){
            this.$util.goTop()
            this.$router.push(`/regiment/index?type=${this.$route.query.type}&id=${item.id}`);
        },
        lists(){
            this.list=[]
            this.$get('/web/home/leagueList',this.param).then(res=>{ 
               this.list=res.result;
               this.param.total= res.result.total
            })
        },
    },
   
    
}
</script>
<style lang="scss" scoped>
.content{
    position: relative;
    background-color: #fff;
    padding: 10px 50px;
    .left-corner {
        line-height: 5px;
        border-bottom: #d6dde6 1px solid;
    }
    ul {
        width: 100%; 

        li{
            width: 100%;
            list-style: none;
            text-align: left;
            display: inline-block;
            line-height: 25px;
            padding-bottom:15px;
            border-bottom: 1px dashed #E0E0E0 ;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            padding-right: 180px;
            position: relative;
                span{
                    font-size: 14px;
                    color: #999999;
                    position: absolute;
                    right: 20px;
                    font-weight: 100;
                }
        }
    }
    .block{
        text-align: center;
        line-height: 50px;
        margin-top: 20px;
    }
}
</style>